import { ITransporter } from "@/models";

interface ITransporterState {
    transporters: ITransporter[];
    activeTransporters: ITransporter[];
}

const initialState: ITransporterState = {
    transporters: [],
    activeTransporters: [],
};

export { ITransporterState, initialState };
